/*
 * http request
 * 1. 防止重复请求
 * 2. 统一loading处理
 * 3. 统一错误提示
 */
import axios from 'axios'
import bus from '@/bus'

const { CancelToken } = axios

const DELAY_TIME = 20000 // 请求超时时间

// 错误返回
const errorMsg = {
  type: 'error',
  code: 'TOAST_NETWORK_ERROR', // DUPLICATE|TIMEOUT|other key
  closeable: true // 该错误是否可关闭 (可关闭则能进一步操作，不可则需用户刷新)
}
// 请求集合，防止重复点击
const requestUrls = []
let requestFlag = ''
// 移除队列中的该请求
const removeRequestUrl = () => {
  requestUrls.splice(requestUrls.indexOf(requestFlag), 1)
}
// 清除 error 缓存
const resetErrorMsg = () => {
  errorMsg.code = 'TOAST_NETWORK_ERROR'
  errorMsg.closeable = true
}
/* 创建axios实例 */
const service = axios.create({
  baseURL: '',
  timeout: DELAY_TIME,
  withCredentials: true
})
const regex = /.*csrftoken=([^;.]*).*$/ // 用于从cookie中匹配 csrftoken值

/**
 * 请求加载框 如果不需要返回空
 * @param {boolean} visable loading 状态 true|false
 * @return loading 组件
 */
const handleLoading = visable => {
  visable ? bus.$loading.show({ maskVisible: false }) : bus.$loading.hide()
}

/* request拦截器 */
service.interceptors.request.use(
  // eslint-disable-next-line consistent-return
  config => {
    resetErrorMsg()
    errorMsg.closeable = !config.disableClose
    config.needLoading && handleLoading(true)
    // 重复点击start=======
    requestFlag = config.url + config.method
    if (requestUrls.indexOf(requestFlag) > -1) {
      config.cancelToken = new CancelToken(cancel => {
        errorMsg.code = 'DUPLICATE'
        cancel('duplicate request')
      })
    } else {
      requestUrls.push(requestFlag)
      config.headers['X-CSRFToken'] = document.cookie.match(regex)
        ? document.cookie.match(regex)[1]
        : null
    }
    // 重复点击end=======
    return config
  },
  error => {
    // NOTE 这种情况未考虑
    Promise.reject(error)
  }
)

/* respone拦截器 */
service.interceptors.response.use(
  response => {
    handleLoading(false)
    removeRequestUrl()
    if (response.data.status === 'error') {
      errorMsg.code = response.data.msg
      bus.handleError(errorMsg)
      return Promise.reject(errorMsg)
    } else {
      return response.data
    }
  },
  error => {
    // 异常处理
    console.log('异常处理：', error.message)
    // 1. 重复请求
    if (error.message && error.message === 'duplicate request') {
      errorMsg.code = 'DUPLICATE'
      return Promise.reject(errorMsg)
    }
    handleLoading(false)
    // 2. 请求超时 "timeout of xxxms exceeded"
    if (error.message && error.message.indexOf('timeout') > -1) {
      errorMsg.code = 'TIMEOUT'
      errorMsg.closeable = false
      bus.handleError(errorMsg)
      removeRequestUrl()
      return Promise.reject(errorMsg)
    }
    // 3. 非2xx || 其他错误 (eg: "Network Error"[断网])
    if (error.response && error.response.data.msg) {
      errorMsg.code = error.response.data.msg
    }
    bus.handleError(errorMsg)
    removeRequestUrl()
    return Promise.reject(errorMsg)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js